import {useLogRocket, currentDateString, extraCallInterval, fetchIboStatusFromV2} from './common';
import {navigateToAmwayConsent, setIboInfoOnReturnToRegistration} from './persist-ibo-info';
import {debounce, memoize} from "underscore";
import styleInject from 'style-inject';
import stepCss from '../css/step1.css?raw';
import legalCss from '../css/legal.css?raw';
import log from 'loglevel';

let logRocket;
useLogRocket((lr) => { logRocket = lr; }).then(() => {});

styleInject(stepCss);
styleInject(legalCss);

window.step1module = {
    isComplimentary: false,
    isIboSet: false,
    isIboError: false,
    isIboInactive: false,
    isIboNumberInUse: false,
    iboMessages: {amway: '', duplicate: '', wasComplimentaryNotEligible: ''},
    consentProvided: false
};

const clearIboMessages = () => {
    const iboStatus = window.step1module;
    iboStatus.iboMessages = {amway: '', duplicate: '', wasComplimentaryNotEligible: ''};
};

const iboNumberId = 'IboNumber';

window.step1module.setIboVerified = async (isSet, userAction) => {
    window.step1module.isIboSet = isSet;
    if (isSet) {
        // clear the IBO eligibility cache if we are marking the IBO number as set
        const iboNumber = document.getElementById(iboNumberId).value;
        await clearIboEligibilityCache(iboNumber, () => {
            enableDisableAgreementButton();
            lookupIboQualifies(userAction);
        });
    } else {
        enableDisableAgreementButton();
        lookupIboQualifies(userAction);
    }
}

window.step1module.navigateToAmwayConsent = () => {
    $('body').addClass('waiting');
    navigateToAmwayConsent();
}

window.step1module.agreeNextPage = () => {
    $('body').addClass('waiting');
    setTimeout(() => {
        document.getElementById('frmSubmit').submit();
    }, 300);
};

window.step1module.goToLandingPage = () => {
    document.getElementById('frmLanding').submit();
};

const onChkSponsorChange = window.step1module.onChkSponsorChange = (elem) => {
    lookupSponsor();
    if (elem.checked) {
        document.getElementById('SponsorNumber').disabled = false;
        $('#SponsorNumber').select();
    } else {
        document.getElementById('SponsorNumber').disabled = true;
    }
    enableDisableAgreementButton();
};

const onChkIboChange = window.step1module.onChkIboChange = (elem) => {
    if (elem.checked) {
        document.getElementById('IboNumber').disabled = false;
        $('#IboNumber').select();
    } else {
        document.getElementById('IboNumber').disabled = true;
    }
    enableDisableAgreementButton();
};

const getTerms = (fnCreateReq, url) => {
    log.info('getting terms and conditions');
    return new Promise((resolve, reject) => {
        const req = fnCreateReq();
        req.open('GET', url, true);

        req.onload = () => {
            if (req.status >= 200 && req.status < 400) {
                resolve(req.responseText);
            } else {
                reject({
                    success: false,
                    message: `${req.status}: ${req.statusText}`
                });
            }
        };

        req.onerror = () => {
            reject({
                success: false,
                message: `${req.status}: ${req.statusText}`
            });
        };

        req.send();
    });
};

const callController = async (fnCreateReq, url, reqBody) => {
    log.info(`calling controller: ${url} -- ${reqBody}`);
    const req = fnCreateReq();
    req.open('POST', url, true);
    req.setRequestHeader('Content-Type', 'application/json');

    return new Promise((resolve, reject) => {
        req.onload = () => {
            if (req.status >= 200 && req.status < 400) {
                resolve(JSON.parse(req.responseText));
            } else {
                reject({
                    success: false,
                    message: `${req.status}: ${req.statusText}`
                });
            }
        };

        req.onerror = () => {
            reject({
                success: false,
                message: `${req.status}: ${req.statusText}`
            });
        };

        const data = JSON.stringify(reqBody);
        req.send(data);
    });
};

const createHttpRequestFn = () => {
    return new XMLHttpRequest();
};
const lookupSponsorUrlId = 'lookupSponsorUrl';
const termsUrlId = 'termsUrl';
const sponsorNumId = 'SponsorNumber';
const hasError = 'has-error';
const iboQualifiesUrl = 'IboQualifiesUrl';
const iboNumberErrorId = 'iboNumberError';
const clearIboCacheUrl = 'ClearIboCacheUrl';

const jumpToEndOfPage = () => {
    // jump to end of page
    log.info('jumping to end of page');
    $('html,body').animate({scrollTop: document.body.scrollHeight}, 500);
    setTimeout(() => {
        document.getElementById('agreementButton').focus();
    }, 400);
};

window.step1module.onAgreementChange = () => {
    if (enableDisableAgreementButton()) {
        jumpToEndOfPage();
    }
};

const enableDisableAgreementButton = () => {
    const isComplimentary = window.step1module.isComplimentary;
    const nonDecoratedChecked = $('input[type="checkbox"]:not([data-non-complimentary]):not([data-complimentary])').not(':checked').length === 0;
    const nonComplimentaryChecked = $('input[type="checkbox"][data-non-complimentary]').not(':checked').length === 0;
    const complimentaryChecked = $('input[type="checkbox"][data-complimentary]').not(':checked').length === 0;
    const requiredChecked = nonDecoratedChecked && (isComplimentary ? complimentaryChecked : nonComplimentaryChecked);
    const sponsorNumInvalid = document.getElementById(sponsorNumId).classList.contains(hasError);
    const iboNumInvalid = document.getElementById(iboNumberId).classList.contains(hasError);
    const isIboSet = window.step1module.isIboSet;
    const iboStatus = window.step1module;
    const isIboIssue = iboStatus.isIboError || iboStatus.isIboInactive;
    const consentProvided = iboStatus.consentProvided;

    if (requiredChecked && !sponsorNumInvalid && !iboNumInvalid && isIboSet && !isIboIssue && consentProvided) {
        document.getElementById('agreementButton').disabled = false;
        return true;
    } else {
        document.getElementById('agreementButton').disabled = true;
        return false;
    }
};

const defaultCheckboxes = () => {
    const nonComplimentaryElems = document.querySelectorAll('[data-non-complimentary]');
    const complimentaryElems = document.querySelectorAll('[data-complimentary]');
    nonComplimentaryElems.forEach(e => e.style.display = 'none');
    complimentaryElems.forEach(e => e.style.display = 'block');
}

const hideShowBasedOnComplimentary = () => {
    const iboStatus = window.step1module;
    const isIboIssue = iboStatus.isIboError || iboStatus.isIboInactive;
    if (!window.step1module.isIboSet || isIboIssue) {
        defaultCheckboxes();
        return;
    }
    const isComplimentary = window.step1module.isComplimentary;
    const consentProvided = window.step1module.consentProvided;
    const nonComplimentaryElems = document.querySelectorAll('[data-non-complimentary]');
    const complimentaryElems = document.querySelectorAll('[data-complimentary]');
    if (isComplimentary || !consentProvided) {
        nonComplimentaryElems.forEach(e => e.style.display = 'none');
        complimentaryElems.forEach(e => e.style.display = 'block');
    } else {
        nonComplimentaryElems.forEach(e => e.style.display = 'block');
        complimentaryElems.forEach(e => e.style.display = 'none');
    }
};

const setAmwayRegistrationDate = (date) => {
    let formattedDate = currentDateString();
    if (date) {
        formattedDate = new Date(date);
        let dd = String(formattedDate.getDate()).padStart(2, '0');
        let mm = String(formattedDate.getMonth() + 1).padStart(2, '0'); //January is 0!
        let yyyy = formattedDate.getFullYear();

        formattedDate = yyyy + '-' + mm + '-' + dd;
    }

    document.getElementById('AmwayRegistrationDate').disabled = false;
    document.getElementById('AmwayRegistrationDate').value = formattedDate;
    document.getElementById('AmwayRegistrationDate').disabled = true;
}

const processAmwayIboEligibilityResult = (d, isError = false) => {
    const iboStatus = window.step1module;
    iboStatus.iboMessages = {...iboStatus.iboMessages, amway: d.message};
    iboStatus.isIboError = isError || d.status.toLowerCase() === 'error';
    iboStatus.isIboInactive = !isError && d.status.toLowerCase() === 'inactive';

    if (!iboStatus.isIboError) {
        const isComplimentary = !d.paymentEligible;
        iboStatus.isComplimentary = !iboStatus.isIboError && !iboStatus.isIboInactive && isComplimentary;
        const consentProvided = d.consentProvided
        iboStatus.consentProvided = !iboStatus.isIboError && !iboStatus.isIboInactive && consentProvided;
        if (iboStatus.consentProvided) {
            setAmwayRegistrationDate(d.applicationDate)
        } else {
            setAmwayRegistrationDate();
        }
    } else {
        iboStatus.isComplimentary = false;
        iboStatus.consentProvided = false;
    }

    const amwayConsentDiv = $('#amwayConsentDiv');
    if (!iboStatus.consentProvided) {
        amwayConsentDiv.css('display', 'block'); // Show the div
    } else {
        amwayConsentDiv.css('display', 'none'); // Hide the div        
    }
}

const resetAmwayIboEligibility = () => {
    const iboStatus = window.step1module;
    iboStatus.isComplimentary = false;
    iboStatus.isIboError = false;
    iboStatus.isIboNumberInUse = false;
    iboStatus.isIboInactive = false;
    iboStatus.consentProvided = false;
    clearIboMessages();
}

const lookupIboQualifies = debounce(async (userAction) => {
    const confirmIboSpan = $('#confirmIboSpan');
    clearIboMessages();
    if (!window.step1module.isIboSet) {
        confirmIboSpan.removeClass('hidden');
        defaultCheckboxes();
        return;
    }
    confirmIboSpan.addClass('hidden');
    log.info('lookup IBO qualifies');
    const url = document.getElementById(iboQualifiesUrl).value;
    const iboNumber = document.getElementById(iboNumberId).value;
    const req = {
        "IboNumber": iboNumber,
        "MemberJoinDate": currentDateString()
    };
    try {
        const iboQualifiesStatus = await callController(createHttpRequestFn, url, req);
        if (iboQualifiesStatus.success) {
            processAmwayIboEligibilityResult(iboQualifiesStatus.data);
            hideShowBasedOnComplimentary();
            if (await validateIboNumber() && userAction) {
                $('#IboNumberConfirmedModal').modal('show');
            }
        } else {
            log.error(iboQualifiesStatus.message);
            processAmwayIboEligibilityResult(iboQualifiesStatus.data);
            hideShowBasedOnComplimentary();
            await validateIboNumber();
        }
    } catch (err) {
        log.error(err);
        resetAmwayIboEligibility();
        hideShowBasedOnComplimentary();
        await validateIboNumber();
    }
}, 300);

const clearIboEligibilityCache = async (iboNumber, fnSuccess) => {
    const url = document.getElementById(clearIboCacheUrl).value;
    const req = {"IboNumber": iboNumber};
    try {
        const clearIboCacheStatus = await callController(createHttpRequestFn, url, req);
        if (clearIboCacheStatus.success) {
            fnSuccess();
        } else {
            log.error(clearIboCacheStatus.message);
        }
    } catch (err) {
        log.error(err);
    }
};

const lookupSponsor = debounce(async () => {
    log.info('lookup sponsor debounce called');
    const url = document.getElementById(lookupSponsorUrlId).value;
    const sponsorNumber = parseInt(document.getElementById(sponsorNumId).value);
    const req = {"SponsorNumber": sponsorNumber};
    const sponsorElem = document.getElementById(sponsorNumId);
    const sponsorNameElem = document.getElementById('sponsorName');
    const verifySponsorElem = document.getElementById('verifySponsor');
    try {
        const lookupSponsorStatus = await callController(createHttpRequestFn, url, req);
        if (lookupSponsorStatus.success) {
            const sponsorName = lookupSponsorStatus.data;
            const message = `Is '<b>${sponsorName}</b>' Your Sponsor? If not, re-type the sponsor number`;
            sponsorNameElem.innerHTML = message;
            sponsorElem.classList.remove(hasError);
            if (verifySponsorElem) {
                verifySponsorElem.textContent = `${sponsorName} (${sponsorNumber})`;
            }
        } else {
            sponsorNameElem.textContent = '';
            log.error(lookupSponsorStatus.message);
            sponsorElem.classList.add(hasError);
            if (verifySponsorElem) {
                verifySponsorElem.textContent = '';
            }
        }
        enableDisableAgreementButton();
    } catch (err) {
        log.error(err);
        sponsorElem.classList.add(hasError);
        sponsorNameElem.textContent = '';
        enableDisableAgreementButton();
    }
}, 300);

const validateIboNumber = async () => {
    const iboNumElem = document.getElementById(iboNumberId);
    const iboNumber = parseInt(iboNumElem.value);
    const iboStatus = window.step1module;
    const iboNumberIsInUse = await checkForActiveIboNumberDuplicates(iboNumber);
    const wasComplimentaryNotPaymentEligible = await checkWasComplimentaryNotPaymentEligible(iboNumber);
    const isIboIssue = iboStatus.isIboError || iboStatus.isIboInactive || iboNumberIsInUse ||
        wasComplimentaryNotPaymentEligible;
    if (iboNumber > 0 && !isIboIssue) {
        iboNumElem.classList.remove(hasError);
    } else {
        iboNumElem.classList.add(hasError);
    }
    const iboErrorElem = document.getElementById(iboNumberErrorId);
    iboErrorElem.innerHTML = GetIboMessageHtml();
    iboErrorElem.style.display = isIboIssue ? 'block' : 'none';

    enableDisableAgreementButton();
    return iboNumber > 0 && !isIboIssue;
};

const GetIboMessageHtml = () => {
    // combine the messages use a <br> tag to separate them
    const iboStatus = window.step1module;
    if (iboStatus.isIboInactive || iboStatus.isIboError) {
        iboStatus.iboMessages = { amway: iboStatus.iboMessages.amway };
    }
    const messageValues = Object.values(iboStatus.iboMessages);
    return messageValues
        .filter(m => (m ?? '').length > 0)
        .join('<br>');
}

const checkForActiveIboNumberDuplicates = async (iboNumber) => {
    if (!iboNumber || Number.isNaN(iboNumber)) {
        log.debug('NOT checking for active IBO number duplicates: invalid IBO number');
        return false
    }
    log.info(`checking for active IBO number duplicates: [${iboNumber}]`);

    const iboStatus = window.step1module;
    const errorMessageHtml = `The IBO Number you entered is associated with another Member's account. ` +
        `Enter your correct IBO Number or contact <a href="mailto:support@ltdhq.com">support@ltdhq.com</a>.`;

    iboStatus.isIboNumberInUse = false;
    iboStatus.iboMessages = {...iboStatus.iboMessages, duplicate: ''};
    try {
        const data = await fetchIboStatusFromV2(iboNumber);
        iboStatus.isIboNumberInUse = data.inUseWithActiveMember;
        iboStatus.iboMessages = {
            ...iboStatus.iboMessages,
            duplicate: data.inUseWithActiveMember ? errorMessageHtml : ''
        };
        return iboStatus.isIboNumberInUse;
    } catch (err) {
        // TODO: If there is an exception, should we return true or false? ... do we want to block the user from registering?
        log.error(err);
        return false;
    }
};

const checkWasComplimentaryNotPaymentEligible = async (iboNumber) => {
    if (!iboNumber || Number.isNaN(iboNumber)) {
        log.debug('NOT checking for past complimentary status and payment eligibility: invalid IBO number');
        return false;
    }
    log.info(`checking for past complimentary status and payment eligibility: [${iboNumber}]`);
    
    const iboStatus = window.step1module;
    const errorMessageHtml = 
        'Your IBO Number is affiliated with an inactive LTD account with an Apprentice Subscription and ' +
        'is not eligible to receive Apprentice again. Please register with LTD once your First ' +
        'Complimentary Membership term has ended with Amway.';
    
    iboStatus.notEligibleWasComplimentary = false;
    iboStatus.iboMessages = {...iboStatus.iboMessages, wasComplimentaryNotEligible: ''};
    try {
        const data = await fetchIboStatusFromV2(iboNumber);
        iboStatus.notEligibleWasComplimentary = data.notEligibleWasComplimentary;
        iboStatus.iboMessages = {
            ...iboStatus.iboMessages,
            wasComplimentaryNotEligible: data.notEligibleWasComplimentary && !data.inUseWithActiveMember ? errorMessageHtml : ''
        };
        return iboStatus.notEligibleWasComplimentary;
    } catch (err) {
        // TODO: If there is an exception, should we return true or false? ... do we want to block the user from registering?
        log.error(err);
        return false;
    }
};

const showIfChecked = (isCheckedId, checkBoxId, fnChkBoxChange) => {
    const isCheckedElem = document.getElementById(isCheckedId);
    const checkBoxElem = document.getElementById(checkBoxId);
    if (isCheckedElem && checkBoxElem) {
        if (isCheckedElem.value === 'True') {
            checkBoxElem.checked = true;
            fnChkBoxChange(checkBoxElem);
        }
    }
};

window.addEventListener('load', async () => {
    await setIboInfoOnReturnToRegistration(async (iboNumber) => {
        await clearIboEligibilityCache(iboNumber, () => {
            // this is where the call to the controller should be made to clear the IBO DynamoDB record
            step1module.setIboVerified(true);
            log.info('clearing IBO DynamoDB record');
        });
    });

    showIfChecked('SponsorNumberChecked', 'SponsorNumberChecked', onChkSponsorChange);
    showIfChecked('IboNumberChecked', 'IboNumberChecked', onChkIboChange);

    validateIboNumber().then(); // ignore the promise
    lookupSponsor();
    lookupIboQualifies();

    if ($('input[type="checkbox"]').not(':checked').length === 0) {
        document.getElementById('SponsorNumber').disabled = false;
        document.getElementById('IboNumber').disabled = false;
    }

    window.step1module.showSubscribeAgreement = () => {
        $('body').addClass('waiting');
        $('#termLink').addClass('waiting');
        const url = document.getElementById(termsUrlId).value;
        getTerms(createHttpRequestFn, url)
            .then(txt => {
                $('#termLink').removeClass('waiting');
                $('body').removeClass('waiting');
                $('#subscribeAgreeContainer').html(txt);
                $('#subscribeAgreeModel').modal({show: true});
            })
            .catch(err => {
                $('#termLink').removeClass('waiting');
                $('body').removeClass('waiting');
                log.error(err);
            });
    }

    // lookup sponsor
    document.getElementById(sponsorNumId).addEventListener('keyup', lookupSponsor);
    // validate IBO number
    document.getElementById(iboNumberId).addEventListener('keyup', lookupIboQualifies);

    // to avoid times when debounce does not work
    setInterval(() => {
        lookupSponsor();
        lookupIboQualifies();
    }, extraCallInterval);
});

// -------- Log Rocket ---------
document.addEventListener("DOMContentLoaded", () => {
    const identityUpdater = memoize((iboNumber) => {
        // there is a limit of calling identify 10 times per page; memoize() to reduce calls
        log.debug(`Identifying user: ${iboNumber} | logRocket is set:`, !!logRocket);
        logRocket?.identify(
            `${iboNumber}`.toLocaleLowerCase().trim(),
        );
    }, (iboNumber) => `${iboNumber}`.toLocaleLowerCase().trim());
    const iboNumberInput = () => document.getElementById('IboNumber');
    iboNumberInput()?.addEventListener('blur', () => {
        const iboNumber = iboNumberInput()?.value;
        identityUpdater(iboNumber);
    });
})
// -------- End Log Rocket ---------